<app-banner [heading]="'INTER SCHOOL COMPETITIONS'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	<!-- ======= About Section ======= -->
    <section id="about" class="about">

       <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/schoolresult/arav1.jpg" alt="best school in kurukshetra">
            </div>
		  </div>
			<div class="col-lg-6 col-md-6">
            <div class="about-content">
              <h6> <b>Arav Verma (Grade- VI)</b></h6>
			  <h4>Date :- 02-01-2022 <br>
			 Aarav,a Grade 6 student of TAGORE GLOBAL SCHOOL,KURUKSHETRA brings laurels to the school
			 by winning in 16th MATSOGI DO NATIONAL CHAMPIONSHIP 2021-2022 held in Maharashtra from 31st Dec. to 2nd Jan.
			 He participated in Martial Arts with thousands of other students pan India and  won a Silver Medal. 
			 His efforts were lauded by the Principal,Dr.Jayeta Auddy. <br>
			<b>Congratulations Arav!! </b>
          </h4></div>
		</div>
		</div>
	</div>
	     <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/schoolresult/harshita2.jpg" alt="best school in kurukshetra">
            </div>
		  </div>
			<div class="col-lg-6 col-md-6">
            <div class="about-content">
              <h6> <b>Harshita (Grade- IX)</b></h6>
			  <h4>Date :- 20-12-2021 <br>
			 Harshita of Grade 9,Tagore Global School Kurukshetra added another feather to the cap by securing FIRST
			 Position in Fancy Dress Competition  in International Geeta Mahotsav. <br>
			Proud of you Harshita!!
          </h4></div>
		</div>
		</div>
	</div>	    
	     <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/schoolresult/harshita1.jpg" alt="best school in kurukshetra">
            </div>
		  </div>
			<div class="col-lg-6 col-md-6">
            <div class="about-content">
              <h6> <b>Harshita (Grade- IX)</b></h6>
			  <h4>Date :14-12-2021 <br>
			  Harshita of Grade 9 ,TGS made her school very proud of herself by standing 
			  FIRST in Inter School Pot Painting Competition in International Geeta Mahotsav,
			  going on  in Kurukshetra these days
          </h4></div>
		</div>
		</div>
	</div>	    
		<div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/schoolresult/basketball.jpg" alt="best school in kurukshetra">
            </div>
		  </div>
			<div class="col-lg-6 col-md-6">
            <div class="about-content">
              <h6> <b> TGS Team</b></h6>
			  <h4>Date : 16-11-2021 <br>
In Basketball Tournament ,our students were Runners up. Vaani and Khushi of Grade 9 were selected to play at State level.<br>
In Athletics,Ishan,Ishu and Pankaj won second position in Discuss throw,High Jump and Javelin throw respectively.<br>
In Netball,U 17 boys were Runners up again.  Hitanshu and Ishu were selected for State level competitions.<br>
In Netball,U 17 girls ,got third position and Anshul,Kanishka and Jasleeb were selected  to play for state level.

			  
          </h4></div>
		</div>
		</div>
	</div>

	
	     <div class="container">
        <div class="row">
	<div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/schoolresult/Kandarp.jpg" alt="best school in kurukshetra">
            </div>
		  </div>
			<div class="col-lg-6 col-md-6">
            <div class="about-content">
              <h6> <b> Kandarp Kaushik</b></h6>
			  <h4> <br>Kandarp kaushik <!-- a Grade 10 --> student of TAGORE GLOBAL SCHOOL, KURUKSHETRA
			  brings laurel to the school by winning in Haryana State Roller Skating Championship held at  Panchkula.
			  About 800 players participated in this championship via four different teams from Sirsa, Gurugram,Faridabad and Kurukshetra.
Kandarp won bronze medal  presented by the President of the Haryana State Roller Skating Association and made a mark in the competition by getting selected for Nationals.<br> </h4>
			  
          </div>
		</div>
		</div>
	</div>
		<div class="container">
        <div class="row">
	<div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/schoolresult/balbhawan.jpg" alt="best school in kurukshetra">
            </div>
		  </div>
			<div class="col-lg-6 col-md-6">
            <div class="about-content">
              <h6> <b>TGS Students</b></h6>
			  <h4> <br>Tagore Global School,KKR participated in Bal Mahotsav 2021 initiated by District Council on the occasion of Children's day.
	         The students too participated enthusiastically in these competitions and they 
			  made us proud by being Runners up in Dramebaaz category by Shivam Gahlot(Grade 7) he was selected for State level, <br>
			  and consolation prize in good handwriting by Neetsay (Grade 6). </h4><h4>
          </h4></div>
		</div>
		</div>
	</div>
	<div class="container">
        <div class="row">
        
          <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/schoolresult/amrit.jpg" alt="best school in kurukshetra">
            </div>
		  </div>
			<div class="col-lg-6 col-md-6">
            <div class="about-content">
              <h6> <b> AMRIT KAUR MANDER </b></h6>
			  <h4> Date :23-07-2021 <br>
			  Position-Ist <br> 
			  Entab Campus Care Edtalks at National level <br> Topic : 'Discussiong taboos in classroom'</h4>
			  <h4> </h4>
          </div>
		</div>
		</div>
	</div>
	     <div class="container">
        <div class="row">
        
		<div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/schoolresult/dhanvi.jpg" alt="best school in kurukshetra">
            </div>
		  </div>
			<div class="col-lg-6 col-md-6">
            <div class="about-content">
              <h6> <b> DHANVI </b></h6>
			  <h4> Date :21-07-2021 <br>
			  Position-Ist  in Solo Dance Competition<br> Haryana State Council for Child Welfare celebrated Bal Mahotsav to provide  
			  a State level platform to the children of all districts. <br> </h4>
          </div>
		</div>
		</div>
	</div>
	     <div class="container">
        <div class="row">
        
		<div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/schoolresult/seerat.jpg" alt="best school in kurukshetra">
            </div>
		  </div>
			<div class="col-lg-6 col-md-6">
            <div class="about-content">
              <h6> <b> SEERAT </b></h6>
			  <h4> Date :31-05-2021 <br>
			  Position- Entry into Guinness World Records <br> Topic: AI for INDIA</h4>
          </div>
		</div>
      </div>
	  </div>
	  <div class="container">
        <div class="row">

          <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/schoolresult/tagore-global-school-kurukshetra-10.jpg" alt="best school in kurukshetra">
            </div>
          </div>
        </div>
	</div>
	</section><!-- End About Section -->
	
  </main>